"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleEditObjective = exports.handleRemoveRow = exports.handleEditRow = exports.handleAddNewRow = exports.handleEditColumn = exports.handleRemoveColumn = exports.handleAddNewColumn = exports.resetAllData = exports.setComparationData = exports.isDataChanged = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const isDataChanged = (comparationData, get) => {
    const { preset, creator, isShared, columns, rows, insights } = get();
    const valueNow = {
        name: preset.name,
        creator: creator,
        isShared: isShared,
        columns: columns,
        rows: rows,
        insights: insights
    };
    let initialValue;
    if (preset.id === 0) {
        initialValue = {
            name: preset.name,
            creator: creator,
            isShared: false,
            columns: [],
            rows: [],
            insights: []
        };
    }
    else {
        initialValue = {
            name: comparationData?.name,
            creator: comparationData?.creator,
            isShared: comparationData?.isShared,
            columns: comparationData?.columns,
            rows: comparationData?.rows,
            insights: comparationData?.insights
        };
    }
    return !(0, isEqual_1.default)(valueNow, initialValue);
};
exports.isDataChanged = isDataChanged;
const setComparationData = (comparationData, set) => {
    const newRows = comparationData?.rows?.filter(({ name }) => name);
    return set({
        isShared: comparationData?.isShared || false,
        creator: comparationData?.creator,
        columns: comparationData?.columns || [],
        rows: newRows || [],
        insights: comparationData?.insights || []
    });
};
exports.setComparationData = setComparationData;
const resetAllData = (creator, set) => {
    return set({
        isShared: false,
        creator: creator,
        columns: [],
        rows: [],
        insights: []
    });
};
exports.resetAllData = resetAllData;
const handleAddNewColumn = (filter, get, set) => {
    const { insights, columns, rows } = get();
    const newSectionData = rows.length == 0
        ? [
            {
                rowNumber: 1,
                rowName: null,
                objective: null
            }
        ]
        : rows?.map((item) => ({
            rowNumber: item.order,
            rowName: item.name,
            objective: null
        }));
    const newInsights = [
        ...insights,
        {
            columnNumber: insights.length + 1,
            columnType: Object.keys(filter)[0].replace('-', ' ').toLocaleLowerCase(),
            columnName: filter[Object.keys(filter)[0]][0],
            sectionData: newSectionData
        }
    ];
    const newColumns = [
        ...columns,
        {
            name: filter[Object.keys(filter)[0]][0],
            type: Object.keys(filter)[0].replace('-', ' ').toLocaleLowerCase(),
            order: insights.length + 1
        }
    ];
    return set({
        insights: newInsights,
        columns: newColumns
    });
};
exports.handleAddNewColumn = handleAddNewColumn;
const handleRemoveColumn = (columnNumber, get, set) => {
    const { insights, columns } = get();
    const newInsights = insights.filter((data) => data.columnNumber !== columnNumber);
    const newColumns = columns.filter((data) => data.order !== columnNumber);
    // reoder column or columnNumber
    newColumns.map((_, index) => {
        newColumns[index].order = index + 1;
    });
    newInsights.map((_, index) => {
        newInsights[index].columnNumber = index + 1;
    });
    return set({
        insights: newInsights,
        columns: newColumns
    });
};
exports.handleRemoveColumn = handleRemoveColumn;
const handleEditColumn = (newFilter, columnNumber, get, set) => {
    const { insights, columns } = get();
    const newInsights = insights.map((data) => {
        if (data.columnNumber === columnNumber)
            return {
                ...data,
                columnType: Object.keys(newFilter)[0]
                    .replace('-', ' ')
                    .toLocaleLowerCase(),
                columnName: newFilter[Object.keys(newFilter)[0]][0]
            };
        return data;
    });
    const newColumns = columns.map((data) => {
        if (data.order === columnNumber)
            return {
                ...data,
                name: newFilter[Object.keys(newFilter)[0]][0],
                type: Object.keys(newFilter)[0].replace('-', ' ').toLocaleLowerCase()
            };
        return data;
    });
    return set({
        insights: newInsights,
        columns: newColumns
    });
};
exports.handleEditColumn = handleEditColumn;
const handleAddNewRow = (textValue, get, set) => {
    const { insights, rows } = get();
    const newInsights = rows.length == 0
        ? insights.map((dataColumn) => {
            return {
                ...dataColumn,
                sectionData: [
                    {
                        rowNumber: 1,
                        rowName: textValue,
                        objective: dataColumn.sectionData[0].objective
                    }
                ]
            };
        })
        : insights.map((data) => ({
            ...data,
            sectionData: [
                ...data.sectionData,
                {
                    rowNumber: data?.sectionData?.length + 1,
                    rowName: textValue,
                    objective: null
                }
            ]
        }));
    const newRows = [
        ...rows,
        {
            name: textValue,
            order: rows.length + 1
        }
    ];
    return set({
        rows: newRows,
        insights: newInsights
    });
};
exports.handleAddNewRow = handleAddNewRow;
const handleEditRow = (orderId, rowName, get, set) => {
    const { insights, rows } = get();
    const newRows = rows.map((data) => {
        if (data.order === orderId)
            return {
                ...data,
                name: rowName
            };
        return data;
    });
    const newInsights = insights.map((data) => ({
        ...data,
        sectionData: data.sectionData.map((item) => {
            if (item.rowNumber === orderId)
                return {
                    ...item,
                    rowName: rowName
                };
            return item;
        })
    }));
    return set({
        rows: newRows,
        insights: newInsights
    });
};
exports.handleEditRow = handleEditRow;
const handleRemoveRow = (orderId, get, set) => {
    const { insights, rows } = get();
    const newInsights = rows.length == 1
        ? insights.map((data) => ({
            ...data,
            sectionData: [
                {
                    rowNumber: 1,
                    rowName: null,
                    objective: null
                }
            ]
        }))
        : insights.map((data) => ({
            ...data,
            sectionData: data.sectionData.filter((item) => item.rowNumber !== orderId)
        }));
    const newRows = rows.filter((data) => data.order !== orderId);
    // reoder row or rowNumber
    newRows.map((_, index) => {
        newRows[index].order = index + 1;
    });
    newInsights.map((data) => ({
        ...data,
        sectionData: data.sectionData.map((_, index) => (data.sectionData[index].rowNumber = index + 1))
    }));
    return set({
        rows: newRows,
        insights: newInsights
    });
};
exports.handleRemoveRow = handleRemoveRow;
const handleEditObjective = (columnNumber, rowNumber, objective, get, set) => {
    const { insights } = get();
    const newInsights = insights?.map((data) => {
        if (data.columnNumber === columnNumber) {
            return {
                ...data,
                sectionData: data.sectionData?.map((item) => {
                    if (item.rowNumber === rowNumber) {
                        return {
                            ...item,
                            objective: objective
                        };
                    }
                    return item;
                })
            };
        }
        return data;
    });
    return set({
        insights: newInsights
    });
};
exports.handleEditObjective = handleEditObjective;
